import { useEffect, useState } from "react";
import Asset from "./Asset";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import navOperations from "redux/Navigation/operations";
import TransferAction from "Store/Component/Transfer/TransferAction";
import { resetAllAssetOrderData } from "client/utils/AssetUtil";
import selectors from "redux/Navigation/selectors";
import ConfirmationBee from "../../../../../assets/images/ConfirmationBee.svg";
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
import { ReactToAPI } from "Service/Transfer/ObjectStructure";
import { CONSTANTS } from "client/utils/constants";
import permissions, { isAuthorized } from "client/utils/Permissions";

const AssetContainer = () => {
  const [showMyCartTransfer, setShowMyCartTransfer] = useState(false);
  const [totalPenaltyFee, setTotalPenaltyFee] = useState<any>(0);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const dispatchNav = navOperations.dispatchNav(dispatch);
  const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch);
  const {
    orderDetails, 
    assets,
    headerNav, 
    isChangesOccured,
    cartAssets,
    getUserDetails,
    docList,
    transferOrderNumber,
    transferRequests,
    dispositionCartList,
    reactivationRequests,
    transferOrderByIdData,
    isChangesOccuredInCart,
    afeReClassificationData,
    billOfSaleUrl
  }: any = useSelector((state?: any) => ({
    orderDetails: state.TransferReducer.orderDetails,
    assets: state.TransferReducer.assets,
    headerNav: selectors.GetHeaderNav(state),
    isChangesOccured: state.RequisitionReducer.isChangesOccured,
    cartAssets: state.TransferReducer.cartAssets,
    getUserDetails: state.UserProfile.getUserDetails,
    docList: state.UploadAttachmentsReducer.list,
    transferOrderNumber: state.TransferReducer.transferOrderNumber,
    transferRequests: state.TransferReducer.transferRequests,
    dispositionCartList: state.TransferReducer.dispositionCartList,
    reactivationRequests: state.TransferReducer.reactivationRequests,
    transferOrderByIdData: state.TransferOrderReducer.transferOrderByIdData,
    isChangesOccuredInCart: state.TransferReducer.isChangesOccuredInCart,
    afeReClassificationData: state.TransferReducer.afeReClassificationData,
    billOfSaleUrl: state.BillOfSaleReducer.billOfSaleUrl
  }));

  const [itemDetailComponent, setItemDetailComponent] = useState(false);
  const [mobile, setMobile] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [showCartClicked, setShowCartClicked] = useState(false)
  const [showCreateRequisition, setShowCreateRequisition] = useState(true)
  const [successAlert, setSuccessAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [headerNavItem, setHeaderNavItem] = useState("home");

  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    additionalBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    additionalBtnnavigateTo: "",
    popupOutlinebtnOnclick: () => { },
    popupPrimarybtnOnclick: () => { },
    popupConfirmatioAdditionalbtnOnclick: () => { },
    actionby: "",
    value: 0,
    comments: "",
    isAdditionalConfirmationBtn: false
  });

  useEffect(() => {
    setHeaderNavItem(headerNav);
  }, [headerNav]);

  const breadcrumlist = [
    {
      text: headerNavItem === "Customer My Orders" ? "Orders" : headerNavItem,
      key: "f1",
      href: "/OrderManagement",
      onClick: (e: any) => {
        e.preventDefault();
       
        if(cartAssets?.length || assets?.length){
          if((orderDetails?.requestType?.label === CONSTANTS.DISPOSITION && cartAssets?.length && (transferOrderByIdData?.orderStatus == undefined)) || (orderDetails?.requestType?.label !== CONSTANTS.DISPOSITION && assets?.length && (transferOrderByIdData?.orderStatus == undefined)) || isChangesOccuredInCart){
            draftSaveConfirmationPopup();
          }else {
            backPopup();
          } 
        }
        else if (isChangesOccured) {
          backPopup();
        } else {
          dispatchNav(headerNavItem);
          dispatchHeaderNav(headerNavItem);
          if(headerNavItem === 'ActiveAsset'){
            navigate('/ordermanagement/activeasset')
          }else{
            navigate('/OrderManagement')
          }
          resetDefaultState();
        }

      },
    },
    { text: "Manage Existing Assets", key: "f2" },
  ];

  let { id, orderType } = useParams();

  useEffect(() => {
    if (id !== undefined) {
      if (mobile) {
        setShowCartClicked(false);
        setShowCart(true);
      } else {
        setShowCartClicked(true);
        setShowCart(true);
      }
    }
  }, [id, mobile,showCartClicked]);

  //disabling the cart when clicking the new draft
  useEffect(() => {
    dismissSuccessAlert()
  },[id])

  useEffect(() => {
    const resizeFun = () => {
      if (window.innerWidth < 600) {
        setMobile(true)
        if (showCartClicked) {
          setShowCart(true)
          setShowCreateRequisition(false)
        }
        else {
          setShowCart(false)
          setShowCreateRequisition(true)
        }
      }
      else {
        setMobile(false);
        if (showCartClicked) {
          setShowCart(true)
          setShowCreateRequisition(true)
        }
        else {
          setShowCart(false)
          setShowCreateRequisition(true)
        }
        setShowCreateRequisition(true)
      }
    }
    resizeFun();

    window.addEventListener('resize', resizeFun)

    return () => window.removeEventListener('resize', resizeFun)
  }, [showCartClicked,id]);

  const resetDefaultState = () => {
    resetAllAssetOrderData(dispatch);
  }


  const dismissSuccessAlert = () => {
    setSuccessAlert(false)
  }

  const dismissErrorAlert = () => {
    setErrorAlert(false)
  }

const draftSaveConfirmationPopup = () => {
  let decriptionTxt = (
    <p>Do you need to save the cart values as draft?</p>
  );
  
  // Check if user has permission to save drafts
  const canSaveDraft = isAuthorized(permissions.RequisitionsCreateUpdate) || isAuthorized(permissions.CreateUpdateTransfers);
  
  setPopupcontent({
    ...Popupcontent,
    titleImg: ConfirmationBee,
    title: "DRAFT CONFIRMATION",
    isDialogVisible: true,
    isTitleWarning: false,
    subtextcontent: decriptionTxt,
    outlineBtnText: "No",
    primaryBtnText: "Yes",
    additionalBtnText: "Cancel",
    isPrimaryBtnDisabled: !canSaveDraft, 
    popupConfirmationOutlinebtnOnclick: () => {
      dispatch(RequisitionAction?.setIsChangesOccured(false))
      dispatch(TransferAction.setIsChangesOccuredInCart(false))
      dispatch(TransferAction.setIsEditOrder(false));
      dispatch(TransferAction.setTransferOrderDetails({}));
      if(headerNavItem == 'ActiveAsset'){
        navigate('/ordermanagement/activeasset')
      }else{
          navigate('/ordermanagement');
      }
      dispatchNav(headerNavItem);
      dispatchHeaderNav(headerNavItem);
      resetDefaultState();
      hideDialog();
    },
    popupConfirmationPrimarybtnOnclick: () => {
      // Only proceed if user has permission
      if (!canSaveDraft) return;
      
      hideDialog();
      let type : any = CONSTANTS.ORDER_SAVE
      dispatch(TransferAction.setIsSaveAsDraft(true))
      dispatch(TransferAction.setIsChangesOccuredInCart(false))
      dispatch(TransferAction.setTransferOrderNumber(""))
      dispatch(TransferAction.setOrderCreationSuccess({}))
          ReactToAPI({
            orderDetails,
            getUserDetails,
            type,
            dispatch,
            docList,
            transferOrderNumber,
            transferRequests,
            dispositionCartList,
            assets,
            reactivationRequests,
            billOfSaleUrl
          })
    },
    popupConfirmatioAdditionalbtnOnclick: () => {
      hideDialog();
    },
    isSingleConfirmationBtn: false,
    isAdditionalConfirmationBtn: true
  });
}

  const backPopup = () => {
    let decriptionTxt = (
      <p>If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?</p>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "UNSAVED CHANGES",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "No",
      primaryBtnText: "Yes",
      popupConfirmationOutlinebtnOnclick: () => {
        hideDialog();
      },
      popupConfirmationPrimarybtnOnclick: () => {
        dispatch(RequisitionAction?.setIsChangesOccured(false))
        dispatch(TransferAction.setIsChangesOccuredInCart(false))
        dispatch(TransferAction.setIsEditOrder(false));
        dispatch(TransferAction.setTransferOrderDetails({}));
        dispatch(TransferAction.setAfeOrderByIdData({}));
        dispatch(TransferAction.setAfeReClassificationData({}));
        if(headerNavItem == 'ActiveAsset'){
          navigate('/ordermanagement/activeasset')
        }else
        {
        navigate('/ordermanagement');
        }
        dispatchNav(headerNavItem);
        dispatchHeaderNav(headerNavItem);
        resetDefaultState();
      },
      isSingleConfirmationBtn: false,
    });
  }

  const backButton = () => {
    dispatch(TransferAction.setIsEditOrder(false));
    dispatch(TransferAction.setTransferOrderDetails({}));
    dispatch(TransferAction.setAfeOrderByIdData({}));
    if(headerNavItem == 'ActiveAsset'){
      navigate('/ordermanagement/activeasset')
    }else{
        navigate('/ordermanagement');
    }
    dispatchNav(headerNavItem);
    dispatchHeaderNav(headerNavItem);
    resetDefaultState();
  }

  const hideDialog = () => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
  };

  const handleClickBack = () => {
    if (mobile) {
      if (showCart) {
        setShowCart(false);
        setShowCreateRequisition(true);
        setShowCartClicked(false)
      }
      else {
        if(cartAssets?.length || assets?.length){
          if((orderDetails?.requestType?.label === CONSTANTS.DISPOSITION && cartAssets?.length && (transferOrderByIdData?.orderStatus == undefined)) || (orderDetails?.requestType?.label !== CONSTANTS.DISPOSITION && assets?.length && (transferOrderByIdData?.orderStatus == undefined)) || isChangesOccuredInCart){
            draftSaveConfirmationPopup();
          }else {
            backPopup();
          } 
        }
        else if(isChangesOccured){
          backPopup();
        }else{
          backButton()
        }
       
      }
    }
    else {
      if(cartAssets?.length || assets?.length){
        if((orderDetails?.requestType?.label === CONSTANTS.DISPOSITION && cartAssets?.length && (transferOrderByIdData?.orderStatus == undefined)) || (orderDetails?.requestType?.label !== CONSTANTS.DISPOSITION && assets?.length && (transferOrderByIdData?.orderStatus == undefined)) || isChangesOccuredInCart){
          draftSaveConfirmationPopup();
        }else {
          backPopup();
        } 
      }
      else if(isChangesOccured){
        backPopup();
      }else{
        backButton()
      }
    }
  }

  useEffect(() => {
    setTimeout(() => {
      setSuccessAlert(false);
      setErrorAlert(false);
    }, 30000)
  }, [showCart, showCartClicked, successAlert, errorAlert])

  const mycartButton = () => {
    if (id !== undefined) {
      setShowCart(true);
      setShowCreateRequisition(false)
     // setShowCartClicked(true)
      setSuccessAlert(false)
    }
    else {
      setShowCart(true);
      setShowCreateRequisition(false)
      setShowCartClicked(true)
      setSuccessAlert(false)
    }
  }

  const isAFERequestType = () => {
    if(id && orderType === CONSTANTS.AFEREQUEST){
      return true;
    } else if(!id && orderDetails?.requestType?.label === CONSTANTS.AFEREQUEST){
      return true;
    }else{
      return false;
    }
  }
  return (
    <Asset
      showMyCartTransfer={showMyCartTransfer}
      setShowMyCartTransfer={setShowMyCartTransfer}
      breadcrumlist={breadcrumlist}
      handleClickBack={handleClickBack}
      itemDetailComponent={itemDetailComponent}
      mobile={mobile}
      mycartButton={mycartButton}
      showCart={showCart}
      setShowCart={setShowCart}
      dismissSuccessAlert={dismissSuccessAlert}
      successAlert={successAlert}
      setItemDetailComponent={setItemDetailComponent}
      showCreateRequisition={showCreateRequisition}
      setShowCreateRequisition={setShowCreateRequisition}
      setSuccessAlert={setSuccessAlert}
      setShowCartClicked={setShowCartClicked}
      orderDetails={orderDetails}
      Popupcontent={Popupcontent}
      hideDialog={hideDialog}
      errorAlert={errorAlert}
      dismissErrorAlert={dismissErrorAlert}
      setErrorAlert={setErrorAlert}
      assets={assets}
      setTotalPenaltyFee = {setTotalPenaltyFee}
      totalPenaltyFee = {totalPenaltyFee}
      isAFERequestType={isAFERequestType}
    />
  )
}

export default AssetContainer;
